import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';


export default function initAgenda(): void {
    const $agendaContainer = document.querySelectorAll<HTMLElement>('.js-agenda');
    $agendaContainer.forEach($container => {
        new Agenda($container);
    });
}

class Agenda {
    $el: HTMLElement | null | undefined;
    $slider: HTMLElement | null | undefined;
    $navigation_prev: HTMLElement | null | undefined;
    $navigation_next: HTMLElement | null | undefined;
    $slides: NodeListOf<HTMLElement> | null | undefined;
    $first_slide_index: number | null | undefined;
    $switchDateLabel: HTMLElement | null | undefined;
    $switchDateButtons: NodeListOf<HTMLElement> | null | undefined;
    swiper: Swiper | null = null;


    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.$slider = $el?.querySelector('.slider-agenda');
        this.$navigation_prev = $el?.querySelector('.button-prev');
        this.$navigation_next = $el?.querySelector('.button-next');
        this.$slides = $el?.querySelectorAll('.agenda-column');

        this.$first_slide_index = 0;
        this.$slides?.forEach((slide, index) => {
            if (slide.classList.contains('swiper-slide-first-active')) {
                this.$first_slide_index = index;
            }
        });

        this.$switchDateLabel = $el?.querySelector('.js-switch-date-label');
        this.$switchDateButtons = $el?.querySelectorAll('.js-btn-switch-date');

        this.init();
    }

    init(): void {
        this.initSwiper();
        this.initSwitchDate();
    }

    initSwiper() : void {
        this.swiper = new Swiper(this.$slider, {
            modules: [Navigation],
            slidesPerView: 1,
            loop: false,
            grabCursor: true,
            allowTouchMove: true,
            initialSlide: this.$first_slide_index,
            navigation: {
                nextEl: this.$navigation_next,
                prevEl: this.$navigation_prev,
            },
            breakpoints: {
                576: {
                    slidesPerView: 'auto',
                },
                768: {
                    slidesPerView: 4,
                },
            },
            on: {
                slideChangeTransitionEnd: () => {
                    const slideActiveDate = this.$el?.querySelector('.swiper-slide-active .column-date');
                    if (this.$switchDateLabel && slideActiveDate) {
                        this.$switchDateLabel.innerHTML = slideActiveDate.innerHTML;
                    }
                },
            }
        });
    }

    initSwitchDate() : void {
        this.$switchDateButtons?.forEach(($btn) => {
            $btn.addEventListener('click', () => {
                const $index = $btn.dataset.slideTarget;
                this.swiper.slideTo($index);
                if (this.$switchDateLabel) {
                    this.$switchDateLabel.innerHTML = $btn.innerHTML;
                }
            });
        });
    }
}
